import { HireDateFields } from "./HireDateFields"
import { HireProcess } from "./HireProcess"
import { productMeta } from "../catalogue"
import { BookingSidebar } from "./BookingSidebar"
import { CheckoutTrust } from "./CheckoutTrust"
import { SelectionFooter } from "./SelectionFooter"
import { AvailabilityContinueLabel } from "./StatusMessages"
import { QuantityStepper } from "./QuantityStepper"

export function BookingLoading({ meta, isMobile, quantity }: { meta: ReturnType<typeof productMeta>; isMobile: boolean; quantity: number }) {
    return <div className="ah-booking-loading" aria-busy="true" aria-label="Loading booking options">
        <div className="ah-layout">
            <BookingSidebar>{!isMobile && <HireProcess />}<CheckoutTrust /></BookingSidebar>
            <main className="ah-main">
                <section className="ah-panel ah-stage-panel ah-postcode-panel">
                    <div className="ah-product-picker">
                        <div className="ah-equipment-heading">
                            <h3 className="ah-section-title">Equipment</h3>
                        </div>
                        <div className="ah-product-selected"><img src={meta.image} alt="" /><span><strong>{meta.name}</strong></span><QuantityStepper quantity={quantity} maximum={quantity} onChange={() => {}} disabled /></div>
                    </div>
                    <div className="ah-section-divider" />
                    <h3 className="ah-section-title">1. Enter your delivery postcode</h3>
                    <div className="ah-field ah-postcode-field"><input aria-label="Delivery postcode" disabled placeholder="E.g. SE23 3XX" /></div>
                    <div className="ah-section-divider" />
                    <h3 className="ah-section-title">2. Select your hire dates</h3>
                    <HireDateFields activeDateField={null} onSelect={() => {}} disabled />
                    <button type="button" className="ah-primary-button ah-stage-action ah-selection-continue" disabled><AvailabilityContinueLabel checking={false} /></button>
                </section>
            </main>
        </div>
        {isMobile && <SelectionFooter loading />}
    </div>
}
